import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";

import { RegulatorySearchFilterType } from "@/components/business/RegulatoryContainer/regulatoryList.types";
import DropDownIcon from "@images/pressList/icon-dropdown.svg";
import SearchFilterTag from "@PressListContainer/shared/components/SearchFilterTag/SearchFilterTag";

import * as S from "./RegulatorySearchFilterSelect.style";

interface Props {
  subTitle: string;
  filterList: RegulatorySearchFilterType[];
  currentFilter: RegulatorySearchFilterType;
  setCurrentFilter: Dispatch<SetStateAction<RegulatorySearchFilterType>>;
  isEditor?: boolean;
}

const RegulatorySearchFilterSelect = ({
  subTitle,
  filterList,
  currentFilter,
  setCurrentFilter,
  isEditor,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropDownRef = useRef<HTMLUListElement | null>(null);
  const selectButtonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    const handleCheckClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const clickOutsideDropDown = !dropDownRef.current?.contains(target);
      const clickSelectButton = selectButtonRef.current?.contains(target);

      if (isOpen && clickOutsideDropDown && !clickSelectButton) {
        setIsOpen(false);
      }
    };
    window.addEventListener("click", handleCheckClickOutside);

    return () => window.removeEventListener("click", handleCheckClickOutside);
  }, [isOpen]);

  return (
    <S.FilterSelectWrapper>
      <S.SelectButton
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        ref={selectButtonRef}
      >
        <SearchFilterTag
          type="search"
          text={currentFilter.name}
          isAllInfo={currentFilter.isAllInfo}
          code={currentFilter.code}
          isEditor={isEditor}
        />

        <img width={8} src={DropDownIcon} alt="filter dropdown icon" />
      </S.SelectButton>
      {isOpen && (
        <S.DropDown ref={dropDownRef}>
          <S.FilterListTitle>{subTitle}</S.FilterListTitle>
          {filterList.map(({ key, name, isAllInfo, code }) => (
            <li key={key}>
              <button
                type="button"
                onClick={() => {
                  setCurrentFilter({ key, name, isAllInfo, code });
                  setIsOpen(false);
                }}
              >
                <SearchFilterTag
                  type="search"
                  text={name}
                  isAllInfo={isAllInfo}
                  code={code}
                  isEditor={isEditor}
                />
              </button>
            </li>
          ))}
        </S.DropDown>
      )}
    </S.FilterSelectWrapper>
  );
};

export default RegulatorySearchFilterSelect;
